<template>
	<div>
		<div class="fullPage" ref="fullPage">

			<!-- <silderbar @scrollToTop="scrollToTop"></silderbar> -->
			<div class="fullPageContainer" ref="fullPageContainer" @mousewheel="mouseWheelHandle"
				@DOMMouseScroll="mouseWheelHandle" @touchstart="handleTouchstart" @touchend="handleTouchend"
				@touchmove="handleTouchmove">
				
				<div ref="holeView" class="circle-hole" v-show="isShowHole">

				</div>
				<div style="position: absolute;top:0;bottom:0;left:0;right:0;margin:auto;inset: 0;z-index: 10001;width: 100%;height:90px;"
					v-show="isShowLOGO">
					<el-image class="animate__animated  animate__pulse custom-duration"
						style="height:90px;width:90px;margin-right:30px;"
						:src="require('../assets/images/heiLOGO.png')"></el-image>
					<el-image v-if="isShow" class="animate__animated animate__slideInRight"
						style="height:90px;width:300px;" fit="cotain"
						:src="require('../assets/images/dyHEI.png')"></el-image>
					<p v-if="isShow" class="animate__animated animate__fadeInUp"
						style="margin-top:50px;font-size:30px;font-weight:bold;">
						<el-image v-if="isShow" style="width: 400px;" fit="cotain"
							:src="require('../assets/images/dyTip.png')"></el-image>
						</p>
				</div>

				<div class="section">
					<homeone @clickLBChange="clickLBChange"></homeone>
				</div>
				<div class="section">
					<hometwo></hometwo>
				</div>
				<div class="section">
					<homethree></homethree>
				</div>

				<div class="section">
					<homefour ref="homeFour"></homefour>
				</div>
				<div class="section">
					<homefive></homefive>
				</div>
				<div class="section">
					<homesix></homesix>
				</div>

				<div class="section">
					<homeseven></homeseven>
				</div>
				<!-- <div > -->
				<Footer @changFootHeight="getFootHeight" ref="FooterV"></Footer>
				<!-- </div> -->

			</div>
		</div>
	</div>
</template>
<script>
	import {
		getEventBus
	} from "../api/eventBus"
	import homeone from '@/components/home_one.vue';
	import hometwo from '@/components/home_two.vue';
	import homethree from '@/components/home_three.vue';
	import homefour from '@/components/home_four.vue';
	import homefive from '@/components/home_five.vue';
	import homesix from '@/components/home_six.vue';
	import homeseven from '@/components/home_seven.vue';
	import silderbar from '@/components/rightSidebar.vue';
	export default {
		name: "Home",
		components: {

			homeone,
			hometwo,
			homethree,
			homefour,
			homefive,
			homesix,
			homeseven,
			silderbar
		},
		watch: {

		},

		
		data() {
			return {
				isShowHole: false,
				isNavScrolled: false,
				isTop: true,
				footH: 0,
				fullpage: {
					current: 1, // 当前的页面编号
					isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
					deltaY: 0 // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
				},
				startTime: undefined, // 记录触摸开始的时间
				startX: undefined, // 记录触摸开始的X坐标，本次主要实现的是上下滑动，所以当前坐标不做强制要求
				startY: undefined, // 记录触摸开始的Y坐标

				isDH: false,
				transparentqqq: 100,
				isShowLOGO: false,
				isShow: false
			};
		},
		beforeDestroy() {
			// getEventBus().$off('scrollToTopz');
			// getEventBus().$off('scrollToTopLast');
			// getEventBus().$off('saveCurrent');
			console.log('beforeDestroy: ');

		},
		mounted() {

			getEventBus().$on("scrollToTopz", res => {
				this.scrollToTop()
			})
			getEventBus().$on("saveCurrent", res => {
				console.log('saveCurrent');
				localStorage.setItem('currentIndex', this.fullpage.current)
			})

			getEventBus().$on("scrollToTopLast", res => {
				// this.scrollToTop()

				let currentIndex = parseInt(localStorage.getItem('currentIndex'))
				if (currentIndex) {
					this.move(currentIndex)
					localStorage.removeItem('currentIndex')
				}

			})

			this.transparentqqq = window.innerWidth / 2 + 50


		},
		
		methods: {

			clickLBChange(index) {
				if (index == 0) {
					this.move(4)
				}
				if (index == 1) {
					this.move(3)
				}
				if (index == 2) {
					this.move(6)
				}
				this.isNavScrolled = true


			},
			scrollToTop() {
				this.move(1)
			},
			getFootHeight(hei) {
				this.footH = hei
			},
			// 往下切换
			gonext() {
				console.log("ssss",this.fullpage.current + 1)
				let len = 8; // 页面的个数
				if (this.fullpage.current + 1 <= len) { // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
					this.fullpage.current += 1; // 页面+1
					this.move(this.fullpage.current); // 执行切换
// console.log("121212")
					this.isNavScrolled = true
				}
			},
			// 往上切换
			pre() {
				if (this.fullpage.current - 1 > 0) { // 如果当前页面编号-1 大于0，则可以执行向下滑动
					this.fullpage.current -= 1; // 页面+1
					this.move(this.fullpage.current); // 执行切换
// console.log("10101")
					this.isNavScrolled = false

				}
			},
			// 滚动事件
			move(index) {
				this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
				this.directToMove(index); //执行滚动
				setTimeout(() => { //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
					this.fullpage.isScrolling = false;
				}, 200);
			},
			// 执行滚动
			directToMove(index) {
				console.log("index", index);
				let FooterV = this.footH ;
				let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
				console.log("9999height",height);
				let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
				var scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
				
				if (index == 8) {
					// -(8 - 1) * height
					
					scrollHeight =  -7 * height + (height - FooterV + 5) + 'px'
				} else {
					scrollHeight = -(index - 1) * height + "px";
				}
				if (index == 1) {
					this.isTop = true
					document.getElementById("nav-bar").style.display = "block";
				} else {
					this.isTop = false
					document.getElementById("nav-bar").style.display = "none";
				}
				if (index == 4) {

					this.$refs['homeFour'].startCount()
				}
				// console.log('FooterV: ', FooterV);
				// console.log('scrollHeight: ', scrollHeight);
				scrollPage.style.transform = `translateY(${scrollHeight})`;
				this.fullpage.current = index;



			},
			// 监听鼠标监听
			mouseWheelHandle(event) {
				// 添加冒泡阻止
// console.log('mouseWheelHandle: ');
// event.detail兼容火狐浏览器
var detaC = 0
				if(event.deltaY)
				{
					detaC = -event.deltaY /100
				}else{
					detaC = -event.detail /3
				}
// 				let detaC =( -event.deltaY || -event.detail) / 100
// console.log('event: ', event);
// 				console.log('detaC: ', detaC);
				if (this.fullpage.current == 1 && !this.isDH) {
					console.log("111111")

					this.transparentqqq = this.transparentqqq + detaC * 50
					// console.log("window.innerWidth", window.innerWidth);
					if (this.transparentqqq > window.innerWidth / 2 + 50) {
						this.transparentqqq = window.innerWidth / 2 + 50
						if (detaC > 0) {
							this.isShowHole = false
						}
					}
					if (detaC < 0) {
						this.isShowHole = true
					}
					// if(this.isShow)
					// {
					// 	this.isDH = true
					// }
					// console.log('this.transparentqqq: ', this.transparentqqq);
					if (this.transparentqqq < 150 && detaC > 0) {
						this.transparentqqq = 151
					}
					if (this.transparentqqq < 150) {
						// console.log('111111: ');
						this.transparentqqq = 0
						this.isShowLOGO = true
						setTimeout(() => {
							this.isShow = true
							setTimeout(() => {
								this.isDH = true
							}, 1000);
						}, 1000);


					} else {
						console.log('2222: ');
						this.isShowLOGO = false
						this.isShow = false
					}
					if (this.transparentqqq < 0) {
						this.transparentqqq = 0
					}
					console.log("33333")
					// console.log("root", this.transparentqqq);

					this.$refs['holeView'].style.maskImage =
						`radial-gradient(circle at center, transparent ${this.transparentqqq}px, black ${this.transparentqqq}px)`

					this.$forceUpdate()
					return
				}
				let evt = event || window.event;
				if (evt.stopPropagation) {
					evt.stopPropagation();
				} else {
					evt.returnValue = false;
				}
				if (this.fullpage.isScrolling) { // 判断是否可以滚动
					return false;
				}
				let e = event.originalEvent || event;
				this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
				console.log('8888888888888: ',this.fullpage.deltaY);
				if (this.fullpage.deltaY > 0) {
					console.log('qqq: ',this.fullpage.deltaY);
					this.gonext();
					this.isDH = false
					this.isShowLOGO = true
				} else if (this.fullpage.deltaY < 0) {
					console.log('aaaa: ',this.fullpage.deltaY);
					this.pre();
					this.isDH = false
					this.isShowLOGO = true
				}
			},
			// 清除触摸事件
			handleTouchmove(event) {
				event.preventDefault()
			},
			//手指按下屏幕
			handleTouchstart(event) {
				this.startTime = Date.now()
				this.startX = event.changedTouches[0].clientX
				this.startY = event.changedTouches[0].clientY
			},
			//手指离开屏幕
			handleTouchend(event) {
				const endTime = Date.now()
				const endX = event.changedTouches[0].clientX
				const endY = event.changedTouches[0].clientY
				//判断按下的时长
				if (endTime - this.startTime > 2000) {
					return
				}
				//滑动的方向
				let direction = "";
				//先判断用户滑动的距离，是否合法，合法:判断滑动的方向 注意 距离要加上绝对值
				if (Math.abs(endY - this.startY) > 10) {
					//滑动方向
					direction = endY - this.startY > 0 ? "down" : "up"
				} else {
					return
				}
				//用户做了合法的滑动操作
				// console.log('方向'+direction)
				if (direction === 'up') {
					this.gonext();

				}
				if (direction === 'down') {
					this.pre();

				}
			}
		}
	};
</script>
<style scoped>
	.nav-barh {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		transition: all 0.3s ease;
		background-color: transparent;
	}

	.fullPage {
		height: 100vh;
		overflow: hidden;
		/* background-color: rgb(189, 211, 186); */
	}

	.fullPageContainer {
		width: 100%;
		height: 100vh;
		transition: all linear 0.5s;
	}

	.section {
		width: 100%;
		height: 100vh;
		background-position: center center;
		background-repeat: no-repeat;
		background-color: #F5F5F5;
	}

	.nav-scrolledh {
		/* background-color: #fff;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
		background: #192F56;
	}

	.circle-hole {
		position: absolute;
		inset: 0;
		z-index: 10001;
		width: 100vw;
		height: 100vh;
		background-color: #fff;
		/* 背景颜色 */
		mask-image: radial-gradient(circle at center, transparent 100%, black 100%);
	}

	.custom-duration {
		animation-duration: 2s;
		/* 设置为2秒 */
	}
</style>


// WEBPACK FOOTER //
// src/views/home.vue